// app/rootSaga
import { takeEvery, takeLatest, throttle, fork, put, take, call } from 'redux-saga/effects'

import fetchAvailableProductsSaga from "state/app/sagas/fetchAvailableProducts";
import { isAppserverOnline } from "lib/validate";

import openURLSaga from "state/app/sagas/openURL";
import openEmailSaga from "state/app/sagas/openEmail";
import openPhoneSaga from "state/app/sagas/openPhone";
import forceRegistrationSaga from "state/app/sagas/forceRegistration";
import processMetadataSaga from "state/app/sagas/processMetadata";
import closeApplicationSaga from "state/app/sagas/closeApplication";
import goBackSaga from "state/app/sagas/goBack";
import attachProductsSaga from "state/app/sagas/attachProductsSaga";

import * as actions from "state/app/actions";
import { validateLocalStoreStructure } from "state/localStore";

export default function* appRootSaga(metadata) {

  // Clear local store if the structure has changed
  yield call(validateLocalStoreStructure);

  // Attach to all fetchAvailableProducts requests
  yield takeEvery(actions.FETCH_AVAILABLE_PRODUCTS, fetchAvailableProductsSaga);

  // Attach to all OPEN_ native actions
  yield takeLatest(actions.OPEN_URL, openURLSaga);
  yield takeLatest(actions.OPEN_EMAIL, openEmailSaga);
  yield takeLatest(actions.OPEN_PHONE, openPhoneSaga);

  yield takeEvery(actions.PROCESS_METADATA, processMetadataSaga);
  yield takeEvery(actions.GO_BACK, goBackSaga);
  yield takeEvery(actions.CLOSE_APPLICATION, closeApplicationSaga);

  // forceRegistration is a one-way ticket, so we should ignore multiple b2b actions
  // debounce, firing the action anyway
  yield throttle(1500, actions.FORCE_REGISTRATION, forceRegistrationSaga);

  // attach/detach product sagags whenever availableProducts is refreshed
  // attachProductsSaga watches for FETCH_AVALABLE_PRODUCTS_COMPLETE
  yield fork(attachProductsSaga);

  if(isAppserverOnline()){
    // initial fetchAvailableProducts
    yield put(actions.fetchAvailableProducts());
  }
  // wait for product sagas to be attached, and then process metadata
  yield take(actions.PRODUCT_SAGAS_ATTACHED);
  if (metadata !== undefined) {
    yield put(actions.processMetadata(metadata));
  }

}



// WEBPACK FOOTER //
// ./src/state/app/sagas/index.js